import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  VertButton,
  VertCheckbox,
  VertModal,
  VertTypography,
} from '@vertem-core/vertice-ds';
import { useDispatch, useSelector } from 'react-redux';
import {
  setIsValidToCheckout,
  setIsVisibleDifal,
  setIsVisibleModal,
} from 'redux/Reducers/Difal/DifalSlice';

const CheckoutDifal = ({ disabledDifal }) => {
  const { isValidCheckout, isVisibleModal, isVisibleDifal } = useSelector(
    (state) => state.DifalSlice
  );

  const dispatch = useDispatch();

  useEffect(() => {
    handleValidateDocument();
  }, []);

  const handleValidateDocument = () => {
    dispatch(setIsVisibleDifal(true));
  };

  function closeModal() {
    dispatch(setIsVisibleModal(false));
  }

  return (
    isVisibleDifal && (
      <>
        <div className="box-checkout-difal">
          <VertCheckbox
            checked={!isValidCheckout}
            onChange={(e) => dispatch(setIsValidToCheckout(!e.target.checked))}
            disabled={disabledDifal}
          >
            <VertTypography.Text strong>
              Aceito os termos
            </VertTypography.Text>
          </VertCheckbox>
          <VertTypography.Text strong>
            <a
                onClick={(e) => {
                  e.stopPropagation();
                  e.cancelBubble = true;
                  dispatch(setIsVisibleModal(true))
                }}
                className="link-view-redemption"
                style={{
                  marginLeft: '0.25em'
                }}
            >
              DIFAL ICMS
            </a>
          </VertTypography.Text>
        </div>

        <VertModal
          centered
          open={isVisibleModal}
          onCancel={closeModal}
          onOk={closeModal}
          title={'DIFAL (Diferencial de Alíquota do ICMS)'}
          className="modal-terms-aprovation"
          footer={[
            <div className="box-terms-modal-footer">
              <VertButton key="submit" type="default" onClick={closeModal}>
                Fechar
              </VertButton>
            </div>,
          ]}
        >
          <VertTypography.Text className="text-terms-modal">
            <VertTypography.Paragraph strong>ATENÇÃO</VertTypography.Paragraph>{' '}
            Em caso de incidência de DIFAL sobre o resgate de produtos no
            catálogo de prêmios, o custeio dessa taxa é de responsabilidade do
            participante.
          </VertTypography.Text>
        </VertModal>
      </>
    )
  );
};

export default CheckoutDifal;

CheckoutDifal.propTypes = {
  isValidToCheckout: PropTypes.bool,
  setIsValidToCheckout: PropTypes.func,
  disabledDifal: PropTypes.bool,
};
